export var TYPES = {
  SLIDE: 'slide',
  FADE: 'fade'
};